import { WTextfield } from '@alice-health/wonderland-react'
import { FunctionComponent } from 'react'
import { useFormContext } from 'react-hook-form'

const ResponsibleNameField: FunctionComponent = () => {
  const {
    register,
    setValue,
    clearErrors,
    trigger,
    formState: { errors }
  } = useFormContext<{
    responsibleName: string
  }>()

  return (
    <>
      <WTextfield
        {...register('responsibleName')}
        placeholder='Nome'
        invalid={!!errors.responsibleName}
        errorText={errors.responsibleName?.message}
        onWChange={ev => setValue('responsibleName', ev.detail)}
        onInput={() => clearErrors('responsibleName')}
        onBlur={() => trigger('responsibleName')}
      />
    </>
  )
}

export { ResponsibleNameField }
